

export const ADD_ONBOARDINGTWO_INIT_ACTION = "ADD_ONBOARDINGTWO_INIT_ACTION";
export const ADD_ONBOARDINGTWO_SUCCESS_ACTION =
  ADD_ONBOARDINGTWO_INIT_ACTION + "_SUCCESS";
export const ADD_ONBOARDINGTWO_FAIL_ACTION =
  ADD_ONBOARDINGTWO_INIT_ACTION + "_ERROR";

export const FETCH_ONBOARDINGTWO_INIT_ACTION = "FETCH_ONBOARDINGTWO_INIT_ACTION";
export const FETCH_ONBOARDINGTWO_SUCCESS_ACTION =
  FETCH_ONBOARDINGTWO_INIT_ACTION + "_SUCCESS";
export const FETCH_ONBOARDINGTWO_FAIL_ACTION =
  FETCH_ONBOARDINGTWO_INIT_ACTION + "_ERROR";